<template>
    <div class="flex flex-column flex-ai">
        <div class="flex1 flex flex-column flex-ai margin-top-40" style="width: 50%;">
            <van-icon name="checked" size="80" color="green"/>
            <div class="f16 dark-2 margin-top">支付成功</div>
            <van-button type="info" round block class="margin-top-40" @click="click">{{url ? '返回' : '返回首页'}}</van-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "payDone",
    data(){
        return{
            url:''
        }
    },
    created() {
        this.url = this.$route.query.url ? decodeURIComponent(this.$route.query.url) : '';
    },
    methods:{
        click(){
            if(this.url){
                window.location.replace(this.url);
                // this.$router.replace({path:this.url});
            }else{
                this.$router.replace({path:'/'});
            }
        }
    }
}
</script>
